import * as React from 'react';
import { NoNavigationPageWrapper } from '../../designSystem/layouts/pageWrappers/NoNavigationPageWrapper';
import { PublicPageProvider } from '../_contexts/PublicPageContext';
import { PasswordResetPanel } from './_components/PasswordResetPanel';

export default function RequestPasswordResetPage (): JSX.Element
{
    return (
        <PublicPageProvider>
            <NoNavigationPageWrapper>

                <PasswordResetPanel
                    header="Gendan adgangskode"
                    helpText="Indtast din e-mailadresse, så sender vi dig et link til at gendanne din adgangskode."
                />

            </NoNavigationPageWrapper>
        </PublicPageProvider>
    );
}